import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

import { RestapiService } from '@app/services/restapi.service';
import { RestPortfolioModel } from '@shared/interfaces/rest-portfolio-model.interface';

@Injectable({
  providedIn: 'root',
})
export class PortfolioService {
  private portfolioIdSource = new BehaviorSubject<number | null>(null);
  portfolioId$ = this.portfolioIdSource.asObservable();

  private switchMessageSource = new BehaviorSubject<{
    reportName: string;
    prevPortfolioId: number;
    newPortfolioId: number;
  } | null>(null);
  switchMessage$ = this.switchMessageSource.asObservable();

  constructor(private restApiService: RestapiService) {}

  update(portfolioDetails: RestPortfolioModel): Observable<RestPortfolioModel> {
    return this.restApiService.update<RestPortfolioModel>(`portfolio/${portfolioDetails.id}`, portfolioDetails);
  }

  setPortfolioId(portfolioId: number) {
    this.portfolioIdSource.next(portfolioId);
    this.portfolioIdSource.next(null);
  }

  setPortfolioSwitchMessage(reportName: string, prevPortfolioId: number, newPortfolioId: number) {
    const message = { reportName, prevPortfolioId, newPortfolioId };
    this.switchMessageSource.next(message);
    return message;
  }
}
